import React from 'react';

import { Typography } from '@mui/material';
import classnames from 'classnames';

import { useIntl } from '@kamernet/core/Intl';
import { PageLayout } from '@kamernet/core/PageLayout';
import { CommonStyles } from '@kamernet/styles/CommonStyles';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';

import { CardSlider } from '@kamernet/components/CardSlider';

import {
  TrustpilotReviewCard,
  TrustpilotReviewCardProps,
} from '../TrustpilotReview';

import styles from './LandlordReviews.module.css';

const reviewData: TrustpilotReviewCardProps[] = [
  {
    id: 0,
    text: 'Within in few days we received a great numbers of interesting reaction to the room. It was easy to make an initial selection, and we invited 4 candidates for a viewing. It took not more than 5 days between the placement of the add on Kamernet and the selection of a new tenant. Fantastic experience.',
    userName: 'Ron',
    reviewDate: '17-03-2023',
  },
  {
    id: 1,
    text: "Kamernet has all the features I needed to let my room, space for information about me, space for applicants' profiles and key information, validates key information to enhance security. Gives (very!) frequent reminders when there are new and unreplied messages. Has a good facility to protect payments. I've used Kamernet in the past and would do so again.",
    userName: 'Jay',
    reviewDate: '05-05-2023',
  },
  {
    id: 2,
    text: 'I could use the earlier advert i made before and got a lot of reactions on my offer. The total interface works fine and i will keep on using it in future years!',
    userName: 'Hm',
    reviewDate: '17-03-2023',
  },
];

export const LandlordReviews = () => {
  const { T } = useIntl();
  const isDesktop = useMediaIsDesktop();

  return (
    <PageLayout.SectionContainer>
      <Typography
        className={classnames(
          styles.title,
          CommonStyles.padding_top_5,
          CommonStyles.padding_bottom_5,
        )}
        variant="h2"
      >
        {T('LBL_HOME_SUPPLY_TESTIMONIAL_TITLE')}
      </Typography>
      <CardSlider visibleItemsCount={isDesktop ? 3 : 1}>
        {reviewData.map(review => (
          <TrustpilotReviewCard
            key={review.id}
            id={review.id}
            text={review.text}
            userName={review.userName}
            reviewDate={review.reviewDate}
          />
        ))}
      </CardSlider>
    </PageLayout.SectionContainer>
  );
};
